module.exports = __webpack_public_path__ + "img/jug.e6d1ceb1.jpeg";